/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { Route, withRouter } from 'react-router-dom';
import CgvProfessional from './CgvProfessional';
import CgvParticular from './CgvParticular';
import logo from '../../logo.svg';
import Cgu from './Cgu';

const GeneralConditions = ({ match, history }) => {
  return (
    <>
      <div style={{ textAlign: 'center', marginBottom: 50 }}>
        <img src={logo} alt="logo sympl" width="300" style={{ margin: 20 }} />
        <h1>Nos conditions général de vente et d&lsquo;utilisations</h1>
        <span>
          Sélectionner les conditions générales que vous souhaitez consulter
        </span>
        <div style={{ marginTop: '5%' }}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => history.push(`${match.url}/professional`)}
          >
            Condition générales de vente professionnel
          </Button>
          <Button
            color="primary"
            variant="contained"
            style={{ margin: '0px 30px' }}
            onClick={() => history.push(`${match.url}/particular`)}
          >
            Condition générales de vente particulier
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => history.push(`${match.url}/cgu`)}
          >
            Condition générales d&lsquo;utilisation
          </Button>
        </div>
      </div>
      <Route path={`${match.url}/professional`} component={CgvProfessional} />
      <Route path={`${match.url}/particular`} component={CgvParticular} />
      <Route path={`${match.url}/cgu`} component={Cgu} />
    </>
  );
};

GeneralConditions.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default withRouter(GeneralConditions);
